import WelcomeMessage from './welcomeMessage'

export default WelcomeMessage
